import React, { useContext, useState } from 'react'
import moment from 'moment'
import DetailsBox from '../../../../components/Cards/DetailsBox'
import EMP from './EMP'
import { TenantSettingsContext, UserContext } from '../../../../App'
import PlanningCompletion from './PlanningCompletion'
import BigModal from '../../../../components/Modals/BigModal'
import API from '../../../../services/API'
import EMPMenu from './EMPMenu'
import DraftEMPVisible from './DraftEMPVisble'
import { EventMetaContext } from '../SingleEvent'

import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import IconButton from '@mui/material/IconButton'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import MoreVert from '@mui/icons-material/MoreVert'

const DocumentGenerator = () => {
  const { eventMeta, loadEvent } = useContext(EventMetaContext)
  const { user } = useContext(UserContext)
  const { orgSettings } = useContext(TenantSettingsContext).orgConfig
  const [openEMPApproval, setOpenEMPApproval] = useState(false)
  const [openMenu, setOpenMenu] = useState(null)

  const handleEMPApproval = () => {
    API.put('/edit-event', {
      eventID: eventMeta._id,
      EMPApproved: true,
      EMPApprovedDate: moment().toDate(),
      EMPApprovedBy: user._id,
    }).then((res) => {
      if (res.status === 200) {
        setOpenEMPApproval(false)
        loadEvent()
      }
    })
  }

  return (
    <Stack component={Paper} padding={2} gap={1} border="solid 2px #268EBB">
      <Stack
        direction="row"
        alignItems="center"
        gap={1}
        justifyContent="space-between"
      >
        <Typography variant="title3">Event Medical Plan</Typography>
        <IconButton onClick={(e) => setOpenMenu(e.currentTarget)}>
          <MoreVert />
        </IconButton>
      </Stack>
      {eventMeta.empNotRequired && (
        <Alert severity="success">Not Required</Alert>
      )}
      <EMPMenu openMenu={openMenu} setOpenMenu={setOpenMenu} />
      {!eventMeta.EMPApproved && !eventMeta.empNotRequired && (
        <>
          <PlanningCompletion />
          <Button
            size="small"
            variant="contained"
            onClick={() => setOpenEMPApproval(true)}
          >
            Approve EMP
          </Button>
          <DraftEMPVisible />
        </>
      )}
      {eventMeta.EMPApproved && !eventMeta.empNotRequired && (
        <Alert severity="success">
          <AlertTitle>
            EMP Approved by{' '}
            {eventMeta.EMPApprovedBy.firstName +
              ' ' +
              eventMeta.EMPApprovedBy.lastName}
          </AlertTitle>
          {moment(eventMeta.EMPApprovedDate).format('Do MMM YYYY')} at{' '}
          {moment(eventMeta.EMPApprovedDate).format('HH:mm')}
        </Alert>
      )}
      {!eventMeta.empNotRequired && (
        <>
          <Typography variant="title3">
            Generate an Event Medical Plan
          </Typography>
          <EMP
            user={{
              firstName: user.firstName,
              lastName: user.lastName,
            }}
            status={eventMeta.EMPApproved ? 'Approved' : 'Draft'}
            orgSettings={orgSettings}
          />
          <BigModal
            open={openEMPApproval}
            onClose={() => setOpenEMPApproval(false)}
            autoWidth
          >
            <Stack gap={1} alignItems="center">
              <Typography>Approve Medical Plan for</Typography>
              <Typography variant="title2" sx={{ textTransform: 'capitalize' }}>
                {eventMeta.title}?
              </Typography>
              <ButtonGroup>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => setOpenEMPApproval(false)}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="success"
                  onClick={handleEMPApproval}
                >
                  Approve
                </Button>
              </ButtonGroup>
            </Stack>
          </BigModal>
        </>
      )}
    </Stack>
  )
}

export default React.memo(DocumentGenerator)
